import { useQuery } from '@tanstack/react-query';
import { useAdminUserSession } from '../../../models/hooks/adminStateHooks';
import { PricebookAddOn } from '../../../admin/components/tools/PricingWizard/types';

export const PRICEBOOK_ADDONS_QUERY_KEY = 'pricebook/addons';
export const PRICEBOOK_ADDONS_NEW_SUBSCRIPTION_QUERY_KEY = 'pricebook/addons/new-subscription';
export const PRICEBOOK_ADDONS_UPGRADE_QUERY_KEY = 'pricebook/addons/upgrade';

/**
 * Fetches ALL pricebook add-ons (for admin/debugging purposes)
 */
export function usePricebookAddOnsQuery({ enabled = true }: { enabled?: boolean } = {}) {
	const userSession = useAdminUserSession();
	return useQuery({
		queryKey: [PRICEBOOK_ADDONS_QUERY_KEY],
		queryFn: () =>
			userSession.webServiceHelper.callAsync<PricebookAddOn[]>('admin/BillingUtilities/GetPricebookAddOns', 'GET'),
		enabled,
		staleTime: 5 * 60 * 1000, // 5 minutes
	});
}

/**
 * Fetches pricebook add-ons available for NEW subscriptions
 * Use this in the Pricing Wizard / new sale flow
 */
export function usePricebookAddOnsForNewSubscriptionQuery({ enabled = true }: { enabled?: boolean } = {}) {
	const userSession = useAdminUserSession();
	return useQuery({
		queryKey: [PRICEBOOK_ADDONS_NEW_SUBSCRIPTION_QUERY_KEY],
		queryFn: () =>
			userSession.webServiceHelper.callAsync<PricebookAddOn[]>(
				'admin/BillingUtilities/GetPricebookAddOnsForNewSubscription',
				'GET'
			),
		enabled,
		staleTime: 5 * 60 * 1000, // 5 minutes
	});
}

/**
 * Fetches pricebook add-ons available for UPGRADES
 * Use this in the Upgrade Wizard flow
 */
export function usePricebookAddOnsForUpgradeQuery({ enabled = true }: { enabled?: boolean } = {}) {
	const userSession = useAdminUserSession();
	return useQuery({
		queryKey: [PRICEBOOK_ADDONS_UPGRADE_QUERY_KEY],
		queryFn: () =>
			userSession.webServiceHelper.callAsync<PricebookAddOn[]>(
				'admin/BillingUtilities/GetPricebookAddOnsForUpgrade',
				'GET'
			),
		enabled,
		staleTime: 5 * 60 * 1000, // 5 minutes
	});
}
